<template>
  <div>
    <!-- LEFT GLASSES -->
    <div
      ref="containerLeft"
      class="component-container glasses space-between"
      @click="showLeftGlassOptions = !showLeftGlassOptions"
    >
      <div class="component__select" :class="{ open: showLeftGlassOptions }">
        <span class="component__select--name">
          <h4>Sélectionner</h4>
          <img v-if="logoLeft" :src="logoLeft" class="image-size" />
          <span v-if="!logoLeft" class="name">
            {{ leftGlasses && leftGlasses.name ? leftGlasses.name : 'Choisir un verre' }}
          </span>
          <RoundButton
            class="bordered button"
            :width="currentScreenWidth > 1280 ? 40 : 30"
            image="ic-arrow-drop-down.svg"
          />
        </span>
      </div>

      <ul
        v-bind:style="{ width: Number($refs.containerLeft.clientWidth) + 35 + 'px' }"
        class="component__select-options"
        v-if="showLeftGlassOptions"
      >
        <li
          class="select--option"
          v-for="option in optionsLeft"
          v-bind:key="option.value"
          @click="selectLeftGlassesOption(option)"
        >
          <label class="labelSelect">
            <input type="checkbox" :value="option" />
            <span class="name">{{ option.name }}</span>
          </label>
        </li>
      </ul>
    </div>

    <div
      ref="containerRight"
      class="component-container glasses"
      v-if="isCompareMode"
      @click="showRightGlassOptions = !showRightGlassOptions"
    >
      <div class="component__select" :class="{ open: showRightGlassOptions }">
        <span class="component__select--name">
          <h4>Comparer à</h4>
          <img v-if="logoRight" :src="logoRight" class="image-size" />
          <span v-if="!logoRight" class="name">
            {{ rightGlasses && rightGlasses.name ? rightGlasses.name : 'Choisir un verre' }}
          </span>
          <RoundButton
            class="bordered button"
            :width="currentScreenWidth > 1280 ? 40 : 30"
            image="ic-arrow-drop-down.svg"
          />
        </span>

        <span class="c-arrow-down" v-if="!showRightGlassOptions"></span>
        <span class="c-arrow-up" v-if="showRightGlassOptions"></span>
      </div>

      <ul
        v-bind:style="{ width: Number($refs.containerRight.clientWidth) + 35 + 'px' }"
        class="component__select-options"
        v-if="showRightGlassOptions"
      >
        <li
          class="select--option"
          v-for="option in optionsRight"
          v-bind:key="option.value"
          @click="selectRightGlassesOption(option)"
        >
          <label class="labelSelect">
            <input type="checkbox" :value="option" />
            <span class="name">{{ option.name }}</span>
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import RoundButton from '@Components/Menus/RoundButton.vue';

export default {
  components: {
    RoundButton,
  },
  props: ['options', 'initRightGlasses', 'initLeftGlasses'],
  mounted() {
    this.selectLeftGlassesOption(this.initLeftGlasses);
    this.selectRightGlassesOption(this.initRightGlasses);
  },
  data: () => ({
    leftGlasses: {},
    rightGlasses: {},
    showLeftGlassOptions: false,
    showRightGlassOptions: false,
  }),
  watch: {
    initRightGlasses() {
      this.selectRightGlassesOption(this.initRightGlasses);
    },
  },
  computed: {
    logoLeft() {
      let src = this.$store.getters.getMediaById('Produits-SVG-' + this.leftGlasses.id);
      return src && src.name ? require(`../../../assets/logo-marque/${src['filename']}`) : null;
    },
    logoRight() {
      let src = this.$store.getters.getMediaById('Produits-SVG-' + this.rightGlasses.id);
      return src && src.name ? require(`../../../assets/logo-marque/${src['filename']}`) : null;
    },
    isCompareMode() {
      return this.$store.getters.isCompareMode;
    },
    currentScreenWidth() {
      return window.outerWidth;
    },
    optionsLeft() {
      return this.options.filter(elem => !this.isCompareMode || !this.rightGlasses || elem.id !== this.rightGlasses.id);
    },
    optionsRight() {
      return this.options.filter(elem => !this.leftGlasses || elem.id !== this.leftGlasses.id);
    },
  },
  methods: {
    selectLeftGlassesOption(option) {
      this.leftGlasses = option;
      if (document.querySelector('.video-blur1')) {
        document
          .querySelector('#video.video1')
          .setAttribute('style', `mask-image :url(/${this.leftGlasses.filter.filter})`);
        document
          .querySelector('#video.video1')
          .setAttribute('style', `-webkit-mask-image :url(/${this.leftGlasses.filter.filter})`);
        document.querySelector('.video-blur1').style.filter = `blur(${this.leftGlasses.filter.blur})`;
      }
      this.$emit('leftGlasses', this.leftGlasses);
      this.$store.commit('setComparisonProductLeft', option);
    },
    selectRightGlassesOption(option) {
      if (!option || !option.id) {
        option = this.optionsRight[this.optionsRight.length - 1];
      }
      if (this.leftGlasses.id === option.id) {
        option = this.optionsRight[this.optionsRight.length - 2];
      }

      this.rightGlasses = option;
      if (document.querySelector('.video-blur2')) {
        document
          .querySelector('#video.video2')
          .setAttribute('style', `mask-image :url(/${this.rightGlasses.filter.filter})`);
        document
          .querySelector('#video.video2')
          .setAttribute('style', `-webkit-mask-image :url(/${this.rightGlasses.filter.filter})`);
        document.querySelector('.video-blur2').style.filter = `blur(${this.rightGlasses.filter.blur})`;
      }
      this.$emit('rightGlasses', this.rightGlasses);
      this.$store.commit('setComparisonProductRight', option);
    },
  },
};
</script>

<style scoped>
.image-size {
  height: 40px;
}

.component__select--name {
  font-size: 0.8rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  transition: background-color 800ms;
}
.rotate {
  transform: rotateZ(180deg);
  transition: transform 300ms;
}
.normal {
  transform: rotateZ(0deg);
  transition: transform 300ms;
}

.no-touchevents .component__select--name:hover > .normal {
  border-color: black;
}

.no-touchevents .component__select:hover {
  /*
  background-color: rgba(255, 255, 255, 1);
*/
  transition: background-color 200ms;
}

.name {
  white-space: nowrap;
  font-size: 24px;
  color: black;
  letter-spacing: 0.5px;
}
.component__select-options .name {
  font-size: 18px;
}
.component__select-options {
  cursor: pointer;
  background-color: white;
  margin: 0;
  position: absolute;
  bottom: 100%;
  text-align: center;
}
.labelSelect {
  position: relative;
  cursor: pointer;
}

.no-touchevents .select--option:hover .labelSelect::after {
  position: absolute;
  top: 100%;
  left: 0;
  content: '';
  width: 50%;
  padding-top: 4px;
  display: block;
  text-align: center;
  margin: auto;
  border-bottom: 2px solid #0088ec;
}
.select--option {
  margin-bottom: 10px;
  height: 35px;
  align-content: center;
  list-style: none;
}

.select--option:last-child {
  border-bottom: none;
}

.select--option:nth-child(2n) {
  background-color: #ffffff;
}

.select--option input {
  display: none;
}
.component__select--name > .name {
  margin-right: 5%;
}
.component__select--name > h4 {
  font-size: 25px;
  margin-right: 5%;
}

.component__select--name > img {
  margin-right: 5%;
}

ul {
  padding: 2% 0 0;
}

h4 {
  white-space: nowrap;
}
@media only screen and (max-width: 1280px) {
  .image-size {
    height: 30px;
  }
}
</style>
